import { render, staticRenderFns } from "./genres-list.vue?vue&type=template&id=3418e0fe&scoped=true"
import script from "./genres-list.vue?vue&type=script&setup=true&lang=js"
export * from "./genres-list.vue?vue&type=script&setup=true&lang=js"
import style0 from "./genres-list.vue?vue&type=style&index=0&id=3418e0fe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3418e0fe",
  null
  
)

export default component.exports